import React from 'react';

export default function BlueTickBadge({ size = 16, style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: 3, flexShrink: 0, ...style }}
    >
      <path
        fill="#1d9bf0"
        d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568-.54.354-.972.853-1.245 1.44-.607-.223-1.264-.27-1.897-.14-.634.132-1.217.437-1.687.882-.445.47-.75 1.053-.882 1.687-.13.633-.083 1.29.14 1.897-.587.274-1.086.706-1.44 1.246-.354.54-.55 1.17-.568 1.816.018.646.214 1.276.568 1.816.354.54.853.972 1.44 1.246-.223.607-.27 1.264-.14 1.897.131.634.436 1.217.882 1.687.47.445 1.053.75 1.687.882.633.13 1.29.083 1.897-.14.274.587.705 1.086 1.245 1.44s1.167.55 1.813.567c.647-.016 1.274-.213 1.814-.567.54-.354.972-.853 1.245-1.44.607.223 1.264.27 1.897.14.634-.132 1.217-.437 1.687-.882.445-.47.75-1.053.882-1.687.13-.633.083-1.29-.14-1.897.586-.274 1.084-.706 1.438-1.246.355-.54.552-1.17.57-1.816zM9.662 14.85l-3.429-3.428 1.293-1.293 2.136 2.136 4.972-4.972 1.293 1.293-6.265 6.264z"
      />
    </svg>
  );
}
